import React from 'react'
import background2 from '../../assets/images/blurCryptoBackground3.jpg'
import mobileBackground from '../../assets/images/mobileBlurCryptoBackgroud.jpg'
import { Fragment } from 'react'
import FloatingContainer from '../../components/global/floatingContainer'
import MyTicketFields from './myticketFields'
import Introduction2 from '../../components/global/introduction2'
const MyTicket = () => {
    return (
        <Fragment>
            <Introduction2
                height={100}
                title1="Submit a Ticket"
                mainTitle="Request Assistance"
                title2="Send the ticket to : Support@eliterecoverires.com"
                backgroundImage={background2}
                mobileBackgroundImage={mobileBackground}
                backgroundColor='none'
                mobileBackgroundColor='none'
                children={
                    <FloatingContainer
                        children={
                            <MyTicketFields />
                        }
                    />
                }
            />
        </Fragment>
    )
}

export default MyTicket